import {initBraintreeClient} from '@stubhub/braintree-web-utils';
import {get} from '@stubhub/rest-method';

const PAYMENT_URL = '/payments/buyer/gateway/v1/clientToken';

/**
 * Obtainst the braintree cleint token from the server, using the given host and query. The call is made to the payment service, to the /pyaments/buyer/gateway/v1/clientToken endpoint
 * @param {String} host the host to use in request
 * @param {object} query query object to use in request
 * @returns the braintree client token
 */
export const getBraintreeToken = async (host, query) => {
  const {btClientToken: {id = null} = {}} = await get({
    host,
    path: PAYMENT_URL,
    query: {
      gcp: true,
      ...query,
    },
    json: true,
  });

  return id;
};

/**
 * Returns an object with braintree token (btToken) and braintree client object (braintree)
 * If some error happens, the error is returned in the `error` field
 * @param {string} host the host to use in requests
 * @param {string} currency currency to set in braintree
 * @param {string} countryCode event country
 * @returns an object with `btToken` and `braintree` client or `error` with the error details
 */
export const fetchBraintreeData = async (host, currency, countryCode) => {
  if (!currency) {
    return null;
  }

  try {
    const query = {
      eventCurrency: currency,
      eventCountry: countryCode,
    };
    let braintree = null;
    const btToken = await getBraintreeToken(host, query);

    try {
      braintree = await initBraintreeClient(btToken);
    } catch (errorObject) {
      return {error: errorObject};
    }

    return {btToken, braintree};
  } catch (errorObject) {
    return {error: errorObject};
  }
};
